import { Navigate } from "react-router-dom";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { can, PermLevel } from "../permissions";
import { IconLoader } from "./Icons";

/** Route guard: renders children only when the current user qualifies —
 * either by role list (`roles`) or by custom grant (`perm`/`anyOf`). */
export default function RequirePerm({
  roles,
  perm,
  level = "read",
  anyOf,
  children,
}: {
  roles?: string[];
  perm?: string;
  level?: Exclude<PermLevel, "off">;
  anyOf?: string[];
  children: JSX.Element;
}) {
  const { user, loading } = useCurrentUser();
  if (loading) {
    return <div style={{ display: "flex", justifyContent: "center", padding: 80 }}><IconLoader size={32} className="muted" /></div>;
  }
  const ok = roles
    ? !!user && roles.includes(user.role)
    : anyOf
      ? anyOf.some((k) => can(user, k, level))
      : can(user, perm!, level);
  return ok ? children : <Navigate to="/" replace />;
}
